module.exports = __webpack_public_path__ + "img/logo-7214.5801a81b.png";